export const MAX_CHARS = 20;

// eslint-disable-next-line import/prefer-default-export
export const brokerReferenceValidator = (t) => (input) => {
    let err = null;
    if (input.length > MAX_CHARS) {
        err = t('auctions.bids-list.validation.broker-reference-too-long', { maxChars: MAX_CHARS });
    }
    return err;
};
